import { axiosGet } from "./axiosFunctions";
import axios from 'axios';

const getOrderByPaymentOrderIDUrl                            = '/api/payment/getOrderByPaymentOrderID';
const getPaymentOrderIDUrl                                   = '/api/payment/getPaymentOrderID';
const getOrderByInvoiceDataUrl                               = '/api/invoice/getInvoiceByInvoiceNo';
const verifyPaymentLinkUrl                                   = '/api/mat/verify-payment';

export const getOrderByPaymentOrderID = async (paymentOrderID) => {   
    const response = await axiosGet(getOrderByPaymentOrderIDUrl, { headers: '', params: {paymentOrderID}});
    return response;
}

export const getPaymentOrderID = async (linkId) => {   
    const response = await axiosGet(getPaymentOrderIDUrl, { headers: '', params: {linkId}});
    return response;
}

export const getOrderByInvoiceData = async (InvoiceId) => {   
    const response = await axiosGet(getOrderByInvoiceDataUrl, { headers: '', params: {invoiceId:InvoiceId}});
    return response;
}

export const verifyPaymentLink = async ({ linkId }) => {
    try {
        const response = await axios.post(verifyPaymentLinkUrl, {
            linkId: linkId
        });
        return response.data;
    } catch (error) {
        console.error("API Error:", {
        message: error.message
    });
        throw error;
    }
};